"use strict";

exports.__esModule = true;
exports.DescriptionListItem = DescriptionListItem;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DescriptionListItemTerm = _styledComponents["default"].dt.withConfig({
  displayName: "DescriptionListItem__DescriptionListItemTerm",
  componentId: "sc-kjr2ld-0"
})(["font-weight:bold;font-size:1.1rem;display:block;"]);
var DescriptionListItemDefinition = _styledComponents["default"].dd.withConfig({
  displayName: "DescriptionListItem__DescriptionListItemDefinition",
  componentId: "sc-kjr2ld-1"
})(["padding:1rem;"]);

/**
 * An item in a Description List.
 */
function DescriptionListItem(props) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(DescriptionListItemTerm, null, props.term), /*#__PURE__*/_react["default"].createElement(DescriptionListItemDefinition, null, props.children));
}